import { apiRequest, buildQuery } from './client';

const root = '/api/v1/me/wallet';
export const walletApi = {
  viewUser: (userId, signal) => apiRequest(`/api/v1/admin/users/${userId}/wallet`, { cache: false, signal }),
  get: (options = {}) => apiRequest(root, { ...options, usePublishingIdentity: true }),
  transactions: (options) => apiRequest(`${root}/transactions${buildQuery(options)}`, { usePublishingIdentity: true }),
  transfer: (body) => apiRequest(`${root}/transfers`, { method: 'POST', body, usePublishingIdentity: true }),
  paymentRequests: () => apiRequest(`${root}/payment-requests`, { usePublishingIdentity: true }),
  paymentRequest: (id) => apiRequest(`${root}/payment-requests/${id}`, { usePublishingIdentity: true }),
  linkedPaymentRequest: (id) => apiRequest(`${root}/payment-requests/${id}`),
  requestPayment: (body) => apiRequest(`${root}/payment-requests`, { method: 'POST', body, usePublishingIdentity: true }),
  payRequest: (id, idempotencyKey) => apiRequest(`${root}/payment-requests/${id}/pay`, { method: 'POST', body: { idempotencyKey }, usePublishingIdentity: true }),
  payLinkedRequest: (id, idempotencyKey) => apiRequest(`${root}/payment-requests/${id}/pay`, { method: 'POST', body: { idempotencyKey } }),
  declineRequest: (id) => apiRequest(`${root}/payment-requests/${id}/decline`, { method: 'POST', usePublishingIdentity: true }),
  cancelRequest: (id) => apiRequest(`${root}/payment-requests/${id}/cancel`, { method: 'POST', usePublishingIdentity: true }),
};
